import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import ReactTable from "react-table";
import { Container } from "reactstrap";
import BaseButtonWithIconAndTooltip from "../../../../../toolkit/baseButtonWithIconAndTooltip";
import ConfirmModal from "../../../common/confirmModal/confirmModal";
import { userHasPermission } from "../../../../../utils/accessTree";
import permissionCodes from "../../../../../utils/permissionCodes";

interface Props {
  referredCodesDetailList: any[];
  partnerMembershipId: String;
  createReferredCodes: () => void;
  deleteReferredCode: (codigoReferidoId: number) => void;
}

interface State {
  confirmModalIsOpen: boolean;
  selectedCodeId: number;
  selectedCodeText: string;
  selectedCodeStatus: string;
}

class ReferredCodesDetailTable extends React.Component<Props, State> {
  state = {
    confirmModalIsOpen: false,
    selectedCodeId: 0,
    selectedCodeText: "",
    selectedCodeStatus: ""
  };
  columns = [
    {
      Header: () => (
        <div style={{ width: "32px" }} className="text-center">
          <BaseButtonWithIconAndTooltip
            id={`createReferredCodes_xggdh`}
            icon={faPlus}
            tooltipTitle={"Crear códigos para programa de referidos"}
            onClick={() => {
              if (!!this.props.createReferredCodes) {
                this.props.createReferredCodes();
              }
            }}
          />
        </div>
      ),
      width: 48,
      className: "text-center",
      Cell: row => {
        const hasPermission = userHasPermission(
          permissionCodes.PARTNER_MEMBERSHIP_TAB_REFERRED_DELETE_CODE
        );
        return (
          <div>
            {hasPermission && (
              <BaseButtonWithIconAndTooltip
                id={`eliminar_cd_ref_${row.original.codigo}`}
                toolTipPlacement="right"
                icon={faTrash}
                tooltipTitle="Eliminar código de referido"
                onClick={() => {
                  this.setState({
                    confirmModalIsOpen: true,
                    selectedCodeId: row.original.id,
                    selectedCodeText: row.original.codigo,
                    selectedCodeStatus: row.original.estatus
                  });
                }}
              />
            )}
          </div>
        );
      }
    },
    {
      Header: "Código",
      className: "text-center",
      accessor: "codigo"
    },
    {
      Header: "Fecha creación",
      className: "text-center",
      accessor: "fechaCreacion"
    },
    {
      Header: "Estatus",
      className: "text-center",
      accessor: "estatus"
    }
  ];

  render() {
    return (
      <Container className="p-0">
        <ConfirmModal
          isOpen={this.state.confirmModalIsOpen}
          title="Eliminar código de referido"
          message={`¿Está seguro que desea eliminar el código "${
            this.state.selectedCodeText
          }"?\n\nEsta acción no se puede deshacer${
            this.state.selectedCodeStatus === "REDIMIDO"
              ? " aunque el código ya está en uso."
              : "."
          }`}
          ok={() => {
            this.props.deleteReferredCode(this.state.selectedCodeId);
            this.setState({
              confirmModalIsOpen: false,
              selectedCodeId: 0,
              selectedCodeText: ""
            });
          }}
          cancel={() => {
            this.setState({
              confirmModalIsOpen: false,
              selectedCodeId: 0,
              selectedCodeText: ""
            });
          }}
          size="md"
        />
        <p className="primaryTitle w-100">Códigos para Referidos</p>
        <ReactTable
          data={this.props.referredCodesDetailList || []}
          columns={this.columns}
          pageSize={20}
          showPagination={false}
          className="mt-3"
        />
      </Container>
    );
  }
}

export default ReferredCodesDetailTable;
